import { DIRECTION_LABELS, type UserReportDirection } from "./types";

export function DirectionPill({
  direction,
}: {
  direction: UserReportDirection;
}) {
  const isTeen = direction === "TEEN_INITIATED";
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full px-3 py-1 text-sm font-medium ${
        isTeen ? "bg-red-100 text-red-700" : "bg-indigo-100 text-indigo-700"
      }`}
    >
      {DIRECTION_LABELS[direction]}
    </span>
  );
}
